import React, { useState } from "react";
import LandingPageContext from "./landingContext";

const LandingPageProvider = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <LandingPageContext.Provider value={{ isDrawerOpen, setIsDrawerOpen }}>
      {children}
    </LandingPageContext.Provider>
  );
};

export default LandingPageProvider;
